module.exports = __webpack_public_path__ + "static/media/add student talent.2ac92570.svg";